/* eslint-disable camelcase */

import type { CbSubscription } from '@lmc/common/types'
import { Tooltip } from 'antd'
import dayjs from 'dayjs'
import _ from 'lodash'
import React from 'react'
import Text from '../../../../../atoms/Text'
import style from './index.module.less'

type PriceProps = {
  sub: CbSubscription
}

const periodLookup = {
  month: 'mo',
  year: 'yr'
}

// coupon_id to coupon name mappings. These values are configured
// in chargebee.
const coupons = {
  'SUPPORTEDLIVING20%DISCOUNT': 'Supported living 20%',
  '100%OFFFAMILYPORTAL_12MONTHS': '100% off Family Portal (12 months)',
  '50%OFFEMAR_3MONTHS': '50% off EMAR (3 months)',
  '15%OFFANNUAL': '15% off annual',
  '25%OFFTOTAL_3MONTHS': '25% off total (3 months)',
  '50%OFFTOTAL_3MONTHS': '50% off total (3 months)',
  PARTNERDISCOUNT_BCA: 'Partner discount (BCA)',
  PARTNERDISCOUNT_MKB: 'Partner discount (MKB)',
  PARTNERDISCOUNT_OACP: 'Partner discount (OACP)',
  TESTSITE: 'Test Site',
  '50%OFFANNUALPLAN(TILL31-JUL-23)': '50% off annual Plan (till 31-Jul-23)',
  'M1_45%OFFANNUALPLAN(TILL31-JUL-23)': '45% off annual Plan (till 31-Jul-23)',
  'M1_30%OFFANNUALPLAN(TILL31-JUL-23)': '30% off annual Plan (till 31-Jul-23)',
  'M1_25%OFFANNUALPLAN(TILL31-JUL-23)': '25% off annual Plan (till 31-Jul-23)',
  'M1_5%OFFANNUALPLAN(TILL31-JUL-23)': '5% off annual Plan (till 31-Jul-23)',
  'M1_70%OFFMONTHLYPLAN(TILL31-OCT-22)':
    '70% off monthly Plan (till 31-Oct-22)',
  'M1_60%OFFMONTHLYPLAN(TILL31-OCT-22)':
    '60% off monthly Plan (till 31-Oct-22)',
  'M1_55%OFFMONTHLYPLAN(TILL31-OCT-22)':
    '55% off monthly Plan (till 31-Oct-22)',
  '40%OFFMONTHLYPLAN(TILL31-OCT-22)': '40% off monthly Plan (till 31-Oct-22)',
  '20%OFFMONTHLYPLAN(TILL31-OCT-22)': '20% off monthly Plan (till 31-Oct-22)',
  'REFERRALTHANKYOU-3MONTHSPRO': 'Referral thank you (3 months Pro)'
}

export const Price = ({ sub }: PriceProps) => {
  const coupon = sub.coupons?.find((coupon) => coupon.coupon_id === sub.coupon)
  // @ts-ignore
  const couponExpiresAt = dayjs.unix(coupon?.apply_till).format('DD-MM-YY')

  const hasDiscount =
    coupon && _.isNumber(sub.mrr) && sub.mrr !== sub.plan_amount

  const showDate =
    coupon?.apply_till &&
    couponExpiresAt &&
    couponExpiresAt !== '' &&
    couponExpiresAt !== null

  const plan_amount = sub?.subscription_items?.[0]?.amount || sub?.plan_amount

  return (
    <>
      {hasDiscount ? (
        <div>
          <Text style={{ lineHeight: 'none' }}>
            {/* @ts-ignore */}
            <strong>£{sub.mrr / 100}</strong>
          </Text>
          <Text color="darkgrey" style={{ lineHeight: 'none' }}>
            {/* @ts-ignore */}/
            {periodLookup[sub.billing_period_unit] || sub.billing_period_unit}{' '}
            +VAT
          </Text>
        </div>
      ) : null}
      <div style={hasDiscount ? { textDecoration: 'line-through' } : {}}>
        <Text style={{ lineHeight: 'none' }}>
          <strong>£{plan_amount ? Number(plan_amount) / 100 : 'NaN'}</strong>
        </Text>
        <Text color="darkgrey" style={{ lineHeight: 'none' }}>
          {/* @ts-ignore */}/
          {periodLookup[sub.billing_period_unit] || sub.billing_period_unit}{' '}
          +VAT
        </Text>
      </div>
      {sub.coupon && (
        <div>
          <Tooltip
            placement="bottomLeft"
            title={
              <div className={style.couponTooltip}>
                <strong>
                  {/* @ts-ignore */}
                  Discount {`(${coupons[sub.coupon] || sub.coupon})`}
                </strong>
                {showDate && (
                  <div>
                    <span>Valid until {couponExpiresAt}</span>
                  </div>
                )}
              </div>
            }
          >
            <Text
              as="p2"
              className={style.coupon}
              style={{ cursor: 'pointer' }}
            >
              Coupon applied
            </Text>
          </Tooltip>
        </div>
      )}
    </>
  )
}

export default Price
